import { Flex } from '@chakra-ui/react'
import { useEffect, useState } from 'react'
import { ButtonCmp } from '../../../../../components/ButtonCmp'
import { ImgSah } from '../../../../../components/ImgSah'
import { ModalBase } from '../../../../../components/ModalBase'
import { appApi } from '../../../../../services/appApi'
import { iPDI } from '../../../../PDI/Criar'
import { AcaoCard } from '../Acao'

interface props {
  isOpen: boolean
  onRequestClose: () => void
  onConfirm: (pdis: iPDI[]) => void
  id: string
  participanteId: string
  pdiId?: string
}

export const ModalAcoesRemanejo: React.FC<props> = ({ isOpen, onRequestClose, onConfirm, id, participanteId, pdiId }) => {
  const [PDIs, setPDIs] = useState<iPDI[]>([])
  const [AcoesId, setAcoesId] = useState<string[]>([])

  function getPdis(): void {
    appApi.get(`FeedbackPersonalizado/${id}/Participante/${participanteId}/PDIs?pdiId=${pdiId ?? ''}`)
      .then((res) => setPDIs(res.data))
      .catch((err) => console.log(err))
  }

  function GetPdisSelecionados(): iPDI[] {
    const pdis: iPDI[] = []
    PDIs.forEach(e => {
      if (e.acoes.some(a => AcoesId.includes(a.id))) {
        const pdi = e
        pdi.acoes = e.acoes.filter(a => AcoesId.includes(a.id))
        pdis.push(pdi)
      }
    })
    return pdis
  }

  function OnChangeAcoesId(aid: string): void {
    if (AcoesId.includes(aid)) {
      setAcoesId(AcoesId.filter(a => a !== aid))
    } else {
      setAcoesId([...AcoesId, aid])
    }
  }

  useEffect(() => {
    getPdis()
  }, [])
  return (
        <ModalBase
            isOpen={isOpen}
            onClose={onRequestClose}
            Titulo={'Selecionar ações não concluídas de PDIs anteriores'}
            Width='52rem'
        >
            <Flex flexDir={'column'} gap={'1.25rem'} px={'1rem'} pt={'.5rem'}>
                {PDIs.map(e => {
                  return <>
                        {e.acoes.map(a => {
                          return <AcaoCard
                                acao={a}
                                onSelect={OnChangeAcoesId}
                                selected={AcoesId.includes(a.id)}
                            />
                        })}
                    </>
                })}
                {PDIs.length === 0 && <ImgSah textoPersonalizado='Não foi encontrada nenhuma ação para remanejar'></ImgSah>}
            </Flex>
            <Flex justifyContent={'end'} gap={'1rem'} p={'1rem'}>
                <ButtonCmp VarColor='c6' onClick={onRequestClose}>Cancelar</ButtonCmp>
                <ButtonCmp VarColor='Green2' onClick={() => onConfirm(GetPdisSelecionados())}>Salvar</ButtonCmp>
            </Flex>

        </ModalBase>
  )
}
